import JSXComponent from "../../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../../dist/jsx-render/dom"
import { IFreigabe } from "../IFreigabe";
import { app } from "../../../../Frame/App";
import { OverlapCalculator } from "../OverlapCalculator";
import { PinPosition } from "../PinPosition";
import { MeasureEditFactory } from "../../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../../../Controls/PagePopup";

// pin size in rem
const PIN_DIMENSION = 3;

// symbol size relative to max 100
const SYMBOL_DIMENSION = 50;
const SYMBOL_DIMENSION_POPUP = 30;
const SYMBOL_Y = 25;
const SYMBOL_Y_POPUP = 10;
const TEXT_Y = 52;
const TEXT_CY = 11;
const TEXT_POPUP_CY = 8;
const POPUP_SPLIT_INDEX = 30;

export type GebaeudePinProps = {
    item: IFreigabe;
    calculator: OverlapCalculator;
}

export class GebaeudePin extends JSXComponent {
    static popoverElements;
    static hasCLoseEvent: boolean;

    props: GebaeudePinProps;

    public pos: PinPosition;

    constructor(props: GebaeudePinProps) {
        super(props);

        if (!GebaeudePin.popoverElements) GebaeudePin.popoverElements = [];
    }

    renderImage(isPopup: boolean) {
        if (this.props.item.svg && this.props.item.svg.length > 0) {
            return <image
                x={(100 - (isPopup ? SYMBOL_DIMENSION_POPUP : SYMBOL_DIMENSION)) / 2}
                y={isPopup ? SYMBOL_Y_POPUP : SYMBOL_Y}
                href={app.resolveUrl(`~/images/Kuraray/Gebaeudeplan/Symbole/${this.props.item.svg}`)}
                height={isPopup ? SYMBOL_DIMENSION_POPUP : SYMBOL_DIMENSION}
                width={isPopup ? SYMBOL_DIMENSION_POPUP : SYMBOL_DIMENSION}
                preserveAspectRatio="xMidYMid meet" />
        }
        return null;
    }

    renderText(isPopup: boolean) {
        let result: any[] = [];

        let y = TEXT_Y;
        let cy = isPopup ? TEXT_POPUP_CY : TEXT_CY;

        if (this.props.item.taetigkeit && this.props.item.taetigkeit.length > 0) {
            result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.taetigkeit}</text>);
            y += cy;
        }

        if (this.props.item.beschreibung && this.props.item.beschreibung.length > 0) {
            if (isPopup) {
                let splitIndex = 0;
                if (this.props.item.beschreibung.length > POPUP_SPLIT_INDEX) {
                    for (let i = 0; i < 10; i++) {
                        const left = POPUP_SPLIT_INDEX - i;
                        const right = POPUP_SPLIT_INDEX + i;
                        if (left > 0 && this.props.item.beschreibung[left] == ' ') {
                            splitIndex = left;
                            break;
                        }
                        if (right < this.props.item.beschreibung.length && this.props.item.beschreibung[right] == ' ') {
                            splitIndex = right;
                            break;
                        }
                    }
                }

                if (splitIndex > 0) {
                    result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.beschreibung.substring(0, splitIndex)}</text>);
                    y += cy;
                    result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.beschreibung.substring(splitIndex)}</text>);
                    y += cy;
                }
                else {
                    result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.beschreibung}</text>);
                    y += cy;
                }
            }
            else {
                result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.beschreibung}</text>);
                y += cy;
            }
        }

        if (this.props.item.abteilung && this.props.item.abteilung.length > 0) {
            result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.abteilung}</text>);
            y += cy;
        }

        if (this.props.item.benutzer && this.props.item.benutzer.length > 0) {
            result.push(<text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text">{this.props.item.benutzer}</text>);
            y += cy;
        }

        if (isPopup) {
            let link: HTMLElement = <text x="50" y={y} text-anchor="middle" fill="#FFFFFF" className="symbol-text symbol-link">{this.props.item.id}</text>;
            result.push(link);

            link.addEventListener("click", (ev: MouseEvent) => {
                ev.cancelBubble = true;
                ev.stopPropagation();
                MeasureEditFactory.showMeasure({
                    measureId: this.props.item.id,
                    templateId: 0,
                    parentId: 0,
                    parentGuid: "0",
                    fullScreen: true,
                    onClose: ((reason: PopupCloseType, id: number) => {
                    })
                });
                this.closeAllOpenPopovers();
            });
            y += cy;
        }

        return result;
    }

    popupElement: HTMLElement =
        <a className="gebaeude-pin popup-pin">
            <svg viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="50" fill={`${this.props.item.color}`} />
                {this.renderImage(true)}
                {...this.renderText(true)}
            </svg>
        </a>

    element: HTMLElement =
        <a className="gebaeude-pin pointer" tabindex="0">
            <svg viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="50" fill={`${this.props.item.color}`} />
                {this.renderImage(false)}
                {/*{...this.renderText(false)}*/}
            </svg>
        </a>

    render(): HTMLElement {
        this.pos = this.props.calculator.calcPosition(this.props.item.x, this.props.item.y, PIN_DIMENSION, PIN_DIMENSION);
        this.element.style.left = `${this.pos.x}px`;
        this.element.style.top = `${this.pos.y}px`;
        this.element.style.width = `${PIN_DIMENSION}rem`;
        this.element.style.height = `${PIN_DIMENSION}rem`;

        const container = document.getElementById("contentFrame");
        this.element.addEventListener("click", (ev: MouseEvent) => {
            ev.cancelBubble = true;
            ev.stopPropagation();
            this.closeAllOpenPopovers();
            GebaeudePin.popoverElements.push(this.element);

            $(this.element).popover('show');
        });

        //$(this.element).popover();
        $(this.element).popover({ html: true, /*trigger: 'focus',*/ container: container, content: this.popupElement, placement: "right" });

        if (!GebaeudePin.hasCLoseEvent) {
            document.body.addEventListener('click', (ev: MouseEvent) => {
                if (!(ev.target as HTMLElement).closest(".popup-pin")) {
                    this.closeAllOpenPopovers();
                }
            });
            GebaeudePin.hasCLoseEvent = true;
        }

        return this.element;
    }

    //**Render an empty pin (a pin with only coordonates)*/
    renderEmptyElement(onDelete: () => any): HTMLElement {
        this.pos = this.props.calculator.calcPosition(this.props.item.x, this.props.item.y, PIN_DIMENSION, PIN_DIMENSION);
        let dynamicSymbol =
            <div class="dynamic-symbol">
                <div class="dynamic-symbol-item" />
            </div> as HTMLElement;
        dynamicSymbol.style.left = `${this.pos.x - 24}px`;
        dynamicSymbol.style.top = `${this.pos.y - 24}px`;
        dynamicSymbol.setAttribute("pin-image", this.props.item.id.toString());
        dynamicSymbol.setAttribute("pin-x", this.props.item.x.toString());
        dynamicSymbol.setAttribute("pin-y", this.props.item.y.toString());

        if (onDelete) {
            (dynamicSymbol.firstChild as HTMLElement).onclick = onDelete;
        }
      

        return dynamicSymbol;
    }

    private closeAllOpenPopovers = () => {
        for (let element of GebaeudePin.popoverElements) {
            $(element).popover("hide");
        }
        GebaeudePin.popoverElements.splice(0, GebaeudePin.popoverElements.length);
    }
}
